export  const  defaultTexts={
    title:'Puzzle-group',
    description:"Puzzle-group",
}

export const REQUEST_TYPE = {
    success: "success",
    error: "error",
    title: "title",
}